// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectShopFrontTypeQueryResult, selectShopFrontTypesPageLoading, selectShopFrontTypesShowInitWaitingMessage} from '../_selectors/shop-front-type.selectors';

export class ShopFrontTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectShopFrontTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectShopFrontTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectShopFrontTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
